// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"c015298b","7992":"704ae499"}[chunkId] + ".chunk.css";
};